export enum AIModelAttr {
	ArchitectureType = 'com.infa.ccgf.models.AIModel.architectureType',
	BiasScore = 'com.infa.ccgf.models.AIModel.biasScore',
	DriftScore = 'com.infa.ccgf.models.AIModel.driftScore',
	Environment = 'com.infa.ccgf.models.AIModel.environment',
	Input = 'com.infa.ccgf.models.AIModel.input',
	Libraries = 'com.infa.ccgf.models.AIModel.libraries',
	ModelFormat = 'com.infa.ccgf.models.AIModel.modelFormat',
	ModelRules = 'com.infa.ccgf.models.AIModel.modelRules',
	Output = 'com.infa.ccgf.models.AIModel.output',
	Purpose = 'com.infa.ccgf.models.AIModel.purpose',
	Reference = 'com.infa.ccgf.models.AIModel.reference',
	SourceModelRepository = 'com.infa.ccgf.models.AIModel.sourceModelRepository',
}

export enum AtlasAttr {
	ClusterName = 'com.infa.odin.models.Atlas.clusterName',
	EndTime = 'com.infa.odin.models.Atlas.endTime',
	FullName = 'com.infa.odin.models.Atlas.fullName',
	Guid = 'com.infa.odin.models.Atlas.guid',
	Operation = 'com.infa.odin.models.Atlas.operation',
	OperationType = 'com.infa.odin.models.Atlas.operationType',
	Owner = 'com.infa.odin.models.Atlas.owner',
	QueryText = 'com.infa.odin.models.Atlas.queryText',
	StartTime = 'com.infa.odin.models.Atlas.startTime',
	Status = 'com.infa.odin.models.Atlas.status',
	UserName = 'com.infa.odin.models.Atlas.userName',
}

export enum AzureDataFactoryAttr {
	CalculationComplexity = 'com.infa.odin.models.AzureDataFactory.calculationComplexity',
	ControlConditions = 'com.infa.odin.models.AzureDataFactory.controlConditions',
	Description = 'com.infa.odin.models.AzureDataFactory.description',
	Expression = 'com.infa.odin.models.AzureDataFactory.expression',
	Folder = 'com.infa.odin.models.AzureDataFactory.folder',
	HtmlLink = 'com.infa.odin.models.AzureDataFactory.htmlLink',
	Type = 'com.infa.odin.models.AzureDataFactory.type',
}

export enum CDMPCollaborationAttr {
	AssetChannels = 'com.infa.ccgf.models.cdmp.collaboration.assetChannels',
	ChannelReference = 'com.infa.ccgf.models.cdmp.collaboration.channelReference',
	ChannelStatus = 'com.infa.ccgf.models.cdmp.collaboration.channelStatus',
	ChannelUniqueReference = 'com.infa.ccgf.models.cdmp.collaboration.channelUniqueReference',
	GlobalRating = 'com.infa.ccgf.models.cdmp.collaboration.globalRating',
	RatingChannels = 'com.infa.ccgf.models.cdmp.collaboration.ratingChannels',
	TargetId = 'com.infa.ccgf.models.cdmp.collaboration.targetId',
	TargetType = 'com.infa.ccgf.models.cdmp.collaboration.targetType',
	UserInteraction = 'com.infa.ccgf.models.cdmp.collaboration.userInteraction',
}

export enum CognosAttr {
	Aggregate = 'com.infa.odin.models.cognos.Aggregate',
	Author = 'com.infa.odin.models.cognos.Author',
	Code = 'com.infa.odin.models.cognos.Code',
	CodePage = 'com.infa.odin.models.cognos.CodePage',
	Columndelimiters = 'com.infa.odin.models.cognos.Columndelimiters',
	Columnoffset = 'com.infa.odin.models.cognos.Columnoffset',
	Connection = 'com.infa.odin.models.cognos.Connection',
	ConnectionManagerDatasource = 'com.infa.odin.models.cognos.ConnectionManagerDatasource',
	CreationTime = 'com.infa.odin.models.cognos.CreationTime',
	Datatype = 'com.infa.odin.models.cognos.Datatype',
	DateFormat = 'com.infa.odin.models.cognos.DateFormat',
	DecimalSeparator = 'com.infa.odin.models.cognos.DecimalSeparator',
	DefaultAggregation = 'com.infa.odin.models.cognos.DefaultAggregation',
	DefaultValue = 'com.infa.odin.models.cognos.DefaultValue',
	Definition = 'com.infa.odin.models.cognos.Definition',
	DesignLevel = 'com.infa.odin.models.cognos.DesignLevel',
	EscapeCharacter = 'com.infa.odin.models.cognos.EscapeCharacter',
	Expression = 'com.infa.odin.models.cognos.Expression',
	Hide = 'com.infa.odin.models.cognos.Hide',
	ImportDate = 'com.infa.odin.models.cognos.ImportDate',
	InitialValue = 'com.infa.odin.models.cognos.InitialValue',
	Kind = 'com.infa.odin.models.cognos.Kind',
	LastModificationTime = 'com.infa.odin.models.cognos.LastModificationTime',
	LeftMultiplicity = 'com.infa.odin.models.cognos.LeftMultiplicity',
	Length = 'com.infa.odin.models.cognos.Length',
	LogicalDataType = 'com.infa.odin.models.cognos.LogicalDataType',
	ModificationTime = 'com.infa.odin.models.cognos.ModificationTime',
	Modifier = 'com.infa.odin.models.cognos.Modifier',
	MultipleSelection = 'com.infa.odin.models.cognos.MultipleSelection',
	NativeId = 'com.infa.odin.models.cognos.NativeId',
	NativeType = 'com.infa.odin.models.cognos.NativeType',
	NullCharacter = 'com.infa.odin.models.cognos.NullCharacter',
	Nullable = 'com.infa.odin.models.cognos.Nullable',
	Numberofbytestoskipbetweenrecords = 'com.infa.odin.models.cognos.Numberofbytestoskipbetweenrecords',
	Numberofinitialrowstoskip = 'com.infa.odin.models.cognos.Numberofinitialrowstoskip',
	Operation = 'com.infa.odin.models.cognos.Operation',
	Optional = 'com.infa.odin.models.cognos.Optional',
	OriginalName = 'com.infa.odin.models.cognos.OriginalName',
	PhysicalDataType = 'com.infa.odin.models.cognos.PhysicalDataType',
	PhysicalName = 'com.infa.odin.models.cognos.PhysicalName',
	Postcondition = 'com.infa.odin.models.cognos.Postcondition',
	Precondition = 'com.infa.odin.models.cognos.Precondition',
	Question = 'com.infa.odin.models.cognos.Question',
	RightMultiplicity = 'com.infa.odin.models.cognos.RightMultiplicity',
	Role = 'com.infa.odin.models.cognos.Role',
	Schema = 'com.infa.odin.models.cognos.Schema',
	Sort = 'com.infa.odin.models.cognos.Sort',
	Stereotype = 'com.infa.odin.models.cognos.Stereotype',
	StoreType = 'com.infa.odin.models.cognos.StoreType',
	SystemMajorVersion = 'com.infa.odin.models.cognos.SystemMajorVersion',
	SystemMinorVersion = 'com.infa.odin.models.cognos.SystemMinorVersion',
	SystemReleaseVersion = 'com.infa.odin.models.cognos.SystemReleaseVersion',
	SystemType = 'com.infa.odin.models.cognos.SystemType',
	SystemTypeOld = 'com.infa.odin.models.cognos.SystemTypeOld',
	TargetObjectReference = 'com.infa.odin.models.cognos.TargetObjectReference',
	ThousandsSeparator = 'com.infa.odin.models.cognos.ThousandsSeparator',
	TrimSpaces = 'com.infa.odin.models.cognos.TrimSpaces',
	Type = 'com.infa.odin.models.cognos.Type',
	TypeLength = 'com.infa.odin.models.cognos.TypeLength',
	TypeName = 'com.infa.odin.models.cognos.TypeName',
	TypeScale = 'com.infa.odin.models.cognos.TypeScale',
	UIId = 'com.infa.odin.models.cognos.UIId',
	URLId = 'com.infa.odin.models.cognos.URLId',
	Usage = 'com.infa.odin.models.cognos.Usage',
	Value = 'com.infa.odin.models.cognos.Value',
}

export enum CoreAttr {
	AssetLifecycle = 'core.assetLifecycle',
	Assignable = 'core.assignable',
	Average = 'core.average',
	BlankCount = 'core.blankCount',
	BlankPercentage = 'core.blankPercentage',
	BusinessDescription = 'core.businessDescription',
	BusinessName = 'core.businessName',
	CalculationComplexity = 'core.calculationComplexity',
	Channels = 'core.channels',
	ClassType = 'core.classType',
	Comment = 'core.comment',
	ConfidenceScore = 'core.confidenceScore',
	ConnectionProvider = 'core.connectionProvider',
	ControlConditions = 'core.controlConditions',
	CreatedBy = 'core.createdBy',
	CreatedOn = 'core.createdOn',
	CurationStatus = 'core.curationStatus',
	DataClassificationExpression = 'core.dataClassificationExpression',
	DataClassificationType = 'core.dataClassificationType',
	DataType = 'core.dataType',
	Description = 'core.description',
	Direction = 'core.direction',
	DistinctCount = 'core.distinctCount',
	DistinctPercentage = 'core.distinctPercentage',
	DuplicateCount = 'core.duplicateCount',
	DuplicatePercentage = 'core.duplicatePercentage',
	EnableAutomation = 'core.enableAutomation',
	EndpointClassType = 'core.endpointClassType',
	EndpointExternalId = 'core.endpointExternalId',
	EndpointIdentity = 'core.endpointIdentity',
	EndpointIsCaseSensitive = 'core.endpointIsCaseSensitive',
	EndpointLocation = 'core.endpointLocation',
	EndpointName = 'core.endpointName',
	EndpointOrigin = 'core.endpointOrigin',
	EndpointResourceName = 'core.endpointResourceName',
	EndpointResourceType = 'core.endpointResourceType',
	Explanation = 'core.explanation',
	Expression = 'core.expression',
	ExternalConnectionName = 'core.externalConnectionName',
	ExternalConnectionUsage = 'core.externalConnectionUsage',
	ExternalId = 'core.externalId',
	Format = 'core.format',
	Frequency = 'core.frequency',
	FrequencyPercentage = 'core.frequencyPercentage',
	GeneratedClassification = 'core.generatedClassification',
	Group = 'core.group',
	Identity = 'core.identity',
	Inferred = 'core.inferred',
	InferredBusinessDescription = 'core.inferredBusinessDescription',
	InferredBusinessName = 'core.inferredBusinessName',
	InferredDataType = 'core.inferredDataType',
	InferredDataTypeDateTimeFormats = 'core.inferredDataTypeDateTimeFormats',
	InferredDataTypeFrequency = 'core.inferredDataTypeFrequency',
	InferredDataTypeFrequencyPercentage = 'core.inferredDataTypeFrequencyPercentage',
	InferredDataTypePrecision = 'core.inferredDataTypePrecision',
	InferredDataTypeScale = 'core.inferredDataTypeScale',
	InferredDataTypeSummaries = 'core.inferredDataTypeSummaries',
	IsRejected = 'core.isRejected',
	JobIdentity = 'core.jobIdentity',
	JobStatus = 'core.jobStatus',
	LastProfiledState = 'core.lastProfiledState',
	LastScannedBy = 'core.lastScannedBy',
	LastScannedOn = 'core.lastScannedOn',
	Location = 'core.location',
	MatchedObjects = 'core.matchedObjects',
	MaxLength = 'core.maxLength',
	MaxValue = 'core.maxValue',
	MergeFacts = 'core.mergeFacts',
	MergeOperation = 'core.mergeOperation',
	MergedClassType = 'core.mergedClassType',
	MergedIdentity = 'core.mergedIdentity',
	MergedLocation = 'core.mergedLocation',
	MergedObjects = 'core.mergedObjects',
	MergedOrigin = 'core.mergedOrigin',
	MergedProducer = 'core.mergedProducer',
	MinLength = 'core.minLength',
	MinValue = 'core.minValue',
	ModifiedBy = 'core.modifiedBy',
	ModifiedOn = 'core.modifiedOn',
	Name = 'core.name',
	NullCount = 'core.nullCount',
	NullPercentage = 'core.nullPercentage',
	NumValuesProfiled = 'core.numValuesProfiled',
	Origin = 'core.origin',
	ParentIdentity = 'core.parentIdentity',
	ParentType = 'core.parentType',
	Pattern = 'core.pattern',
	PatternStatistics = 'core.patternStatistics',
	Position = 'core.Position',
	Precision = 'core.precision',
	Producer = 'core.producer',
	Profiled = 'core.profiled',
	Promoted = 'core.promoted',
	PromotedToClassification = 'core.promotedToClassification',
	RankArray = 'core.rankArray',
	RankIndex = 'core.rankIndex',
	RankType = 'core.rankType',
	Ratings = 'core.Ratings',
	Reference = 'core.reference',
	RejectedGeneratedClassification = 'core.rejectedGeneratedClassification',
	ResourceName = 'core.resourceName',
	ResourceType = 'core.resourceType',
	Role = 'core.role',
	SatisfiedCount = 'core.satisfiedCount',
	SatisfiedPercentage = 'core.satisfiedPercentage',
	Scale = 'core.scale',
	Score = 'core.score',
	ScoreTrend = 'core.scoreTrend',
	Sensitivity = 'core.sensitivity',
	SourceCreatedBy = 'core.sourceCreatedBy',
	SourceCreatedOn = 'core.sourceCreatedOn',
	SourceIdentity = 'core.sourceIdentity',
	SourceModifiedBy = 'core.sourceModifiedBy',
	SourceModifiedOn = 'core.sourceModifiedOn',
	SourceOrigin = 'core.sourceOrigin',
	StakeholderIdentity = 'core.stakeholderIdentity',
	StandardDeviation = 'core.standardDeviation',
	Sum = 'core.sum',
	TargetIdentity = 'core.targetIdentity',
	TargetOrigin = 'core.targetOrigin',
	TopNValueFrequencies = 'core.topNValueFrequencies',
	TopNValueFrequenciesSample = 'core.topNValueFrequenciesSample',
	TotalObjects = 'core.totalObjects',
	TotalRelationships = 'core.totalRelationships',
	UnmatchedObjects = 'core.unmatchedObjects',
	Value = 'core.value',
	ZeroCount = 'core.zeroCount',
	ZeroPercentage = 'core.zeroPercentage',
}

export enum DashboardAttr {
	AssetTypes = 'com.infa.application.dashboard.assetTypes',
	GridColumns = 'com.infa.application.dashboard.gridColumns',
	GroupBy = 'com.infa.application.dashboard.groupBy',
	IncludeCurrentUser = 'com.infa.application.dashboard.includeCurrentUser',
	JobType = 'com.infa.application.dashboard.jobType',
	NoticeBoardContent = 'com.infa.application.dashboard.noticeBoardContent',
	Order = 'com.infa.application.dashboard.order',
	RecommendationTypes = 'com.infa.application.dashboard.recommendationTypes',
	RefreshInterval = 'com.infa.application.dashboard.refreshInterval',
	RowCount = 'com.infa.application.dashboard.rowCount',
	SearchQuery = 'com.infa.application.dashboard.searchQuery',
	TicketStakeholderType = 'com.infa.application.dashboard.ticketStakeholderType',
	TicketStatus = 'com.infa.application.dashboard.ticketStatus',
	TimePeriod = 'com.infa.application.dashboard.timePeriod',
	UserGroups = 'com.infa.application.dashboard.userGroups',
	Users = 'com.infa.application.dashboard.users',
	VisualizationType = 'com.infa.application.dashboard.visualizationType',
}

export enum DataSerializedAttr {
	ContentType = 'com.infa.odin.models.data.serialized.contentType',
	DataType = 'com.infa.odin.models.data.serialized.dataType',
	Encoding = 'com.infa.odin.models.data.serialized.encoding',
	Nullable = 'com.infa.odin.models.data.serialized.nullable',
	Scale = 'com.infa.odin.models.data.serialized.scale',
	Size = 'com.infa.odin.models.data.serialized.size',
	Type = 'com.infa.odin.models.data.serialized.type',
}

export enum DatabricksAttr {
	CalculationComplexity = 'com.infa.odin.models.Databricks.calculationComplexity',
	ControlConditions = 'com.infa.odin.models.Databricks.controlConditions',
	Expression = 'com.infa.odin.models.Databricks.expression',
	HtmlLink = 'com.infa.odin.models.Databricks.htmlLink',
	SourceCode = 'com.infa.odin.models.Databricks.sourceCode',
}

export enum ErstudioAttr {
	AliasName = 'com.infa.odin.models.erstudio.AliasName',
	Author = 'com.infa.odin.models.erstudio.Author',
	BackgroundColor = 'com.infa.odin.models.erstudio.BackgroundColor',
	Bold = 'com.infa.odin.models.erstudio.Bold',
	Cardinality = 'com.infa.odin.models.erstudio.Cardinality',
	Clustered = 'com.infa.odin.models.erstudio.Clustered',
	Code = 'com.infa.odin.models.erstudio.Code',
	ColumnName = 'com.infa.odin.models.erstudio.ColumnName',
	Complete = 'com.infa.odin.models.erstudio.Complete',
	Connection = 'com.infa.odin.models.erstudio.Connection',
	Constraint = 'com.infa.odin.models.erstudio.Constraint',
	CreationTime = 'com.infa.odin.models.erstudio.CreationTime',
	Cycle = 'com.infa.odin.models.erstudio.Cycle',
	DataType = 'com.infa.odin.models.erstudio.DataType',
	DefaultValue = 'com.infa.odin.models.erstudio.DefaultValue',
	Definition = 'com.infa.odin.models.erstudio.Definition',
	DesignLevel = 'com.infa.odin.models.erstudio.DesignLevel',
	DimensionalRole = 'com.infa.odin.models.erstudio.DimensionalRole',
	DimensionalType = 'com.infa.odin.models.erstudio.DimensionalType',
	DisplayOptions = 'com.infa.odin.models.erstudio.DisplayOptions',
	DisplayText = 'com.infa.odin.models.erstudio.DisplayText',
	Exclusive = 'com.infa.odin.models.erstudio.Exclusive',
	Expression = 'com.infa.odin.models.erstudio.Expression',
	FireOnDelete = 'com.infa.odin.models.erstudio.FireOnDelete',
	FireOnInsert = 'com.infa.odin.models.erstudio.FireOnInsert',
	FireOnUpdate = 'com.infa.odin.models.erstudio.FireOnUpdate',
	FontColor = 'com.infa.odin.models.erstudio.FontColor',
	FontName = 'com.infa.odin.models.erstudio.FontName',
	FontSize = 'com.infa.odin.models.erstudio.FontSize',
	Generate = 'com.infa.odin.models.erstudio.Generate',
	Group = 'com.infa.odin.models.erstudio.Group',
	GroupByClause = 'com.infa.odin.models.erstudio.GroupByClause',
	HavingClause = 'com.infa.odin.models.erstudio.HavingClause',
	Height = 'com.infa.odin.models.erstudio.Height',
	Identifying = 'com.infa.odin.models.erstudio.Identifying',
	ImportDate = 'com.infa.odin.models.erstudio.ImportDate',
	IncrementValue = 'com.infa.odin.models.erstudio.IncrementValue',
	InitialValue = 'com.infa.odin.models.erstudio.InitialValue',
	Italic = 'com.infa.odin.models.erstudio.Italic',
	Kind = 'com.infa.odin.models.erstudio.Kind',
	LastModificationTime = 'com.infa.odin.models.erstudio.LastModificationTime',
	Length = 'com.infa.odin.models.erstudio.Length',
	LineColor = 'com.infa.odin.models.erstudio.LineColor',
	LinePoints = 'com.infa.odin.models.erstudio.LinePoints',
	LowerBound = 'com.infa.odin.models.erstudio.LowerBound',
	Max = 'com.infa.odin.models.erstudio.Max',
	MaximumValue = 'com.infa.odin.models.erstudio.MaximumValue',
	Min = 'com.infa.odin.models.erstudio.Min',
	MinimumValue = 'com.infa.odin.models.erstudio.MinimumValue',
	ModificationTime = 'com.infa.odin.models.erstudio.ModificationTime',
	Modifier = 'com.infa.odin.models.erstudio.Modifier',
	NativeDataType = 'com.infa.odin.models.erstudio.NativeDataType',
	NativeId = 'com.infa.odin.models.erstudio.NativeId',
	NativeLogicalDataType = 'com.infa.odin.models.erstudio.NativeLogicalDataType',
	NativeType = 'com.infa.odin.models.erstudio.NativeType',
	Notation = 'com.infa.odin.models.erstudio.Notation',
	Note = 'com.infa.odin.models.erstudio.Note',
	Nullable = 'com.infa.odin.models.erstudio.Nullable',
	OnDelete = 'com.infa.odin.models.erstudio.OnDelete',
	OnInsert = 'com.infa.odin.models.erstudio.OnInsert',
	OnUpdate = 'com.infa.odin.models.erstudio.OnUpdate',
	Operation = 'com.infa.odin.models.erstudio.Operation',
	OperationDescription = 'com.infa.odin.models.erstudio.OperationDescription',
	OrderByClause = 'com.infa.odin.models.erstudio.OrderByClause',
	PhysicalName = 'com.infa.odin.models.erstudio.PhysicalName',
	Postcondition = 'com.infa.odin.models.erstudio.Postcondition',
	Precondition = 'com.infa.odin.models.erstudio.Precondition',
	Scope = 'com.infa.odin.models.erstudio.Scope',
	SelectType = 'com.infa.odin.models.erstudio.SelectType',
	Sequence = 'com.infa.odin.models.erstudio.Sequence',
	ShapeType = 'com.infa.odin.models.erstudio.ShapeType',
	SortOrder = 'com.infa.odin.models.erstudio.SortOrder',
	Source = 'com.infa.odin.models.erstudio.Source',
	StartValue = 'com.infa.odin.models.erstudio.StartValue',
	StoreType = 'com.infa.odin.models.erstudio.StoreType',
	Strike = 'com.infa.odin.models.erstudio.Strike',
	SystemMajorVersion = 'com.infa.odin.models.erstudio.SystemMajorVersion',
	SystemMinorVersion = 'com.infa.odin.models.erstudio.SystemMinorVersion',
	SystemReleaseVersion = 'com.infa.odin.models.erstudio.SystemReleaseVersion',
	SystemType = 'com.infa.odin.models.erstudio.SystemType',
	SystemTypeOld = 'com.infa.odin.models.erstudio.SystemTypeOld',
	TableName = 'com.infa.odin.models.erstudio.TableName',
	Text = 'com.infa.odin.models.erstudio.Text',
	TriggerType = 'com.infa.odin.models.erstudio.TriggerType',
	TypeName = 'com.infa.odin.models.erstudio.TypeName',
	Underline = 'com.infa.odin.models.erstudio.Underline',
	Unique = 'com.infa.odin.models.erstudio.Unique',
	UniqueKey = 'com.infa.odin.models.erstudio.UniqueKey',
	UpperBound = 'com.infa.odin.models.erstudio.UpperBound',
	Usage = 'com.infa.odin.models.erstudio.Usage',
	UserDataType = 'com.infa.odin.models.erstudio.UserDataType',
	Value = 'com.infa.odin.models.erstudio.Value',
	ViewStatement = 'com.infa.odin.models.erstudio.ViewStatement',
	ViewStatementType = 'com.infa.odin.models.erstudio.ViewStatementType',
	ViewType = 'com.infa.odin.models.erstudio.ViewType',
	WhereClause = 'com.infa.odin.models.erstudio.WhereClause',
	Width = 'com.infa.odin.models.erstudio.Width',
	X = 'com.infa.odin.models.erstudio.X',
	Y = 'com.infa.odin.models.erstudio.Y',
	Z = 'com.infa.odin.models.erstudio.Z',
}

export enum ErwinAttr {
	AliasName = 'com.infa.odin.models.erwin.AliasName',
	Author = 'com.infa.odin.models.erwin.Author',
	Cache = 'com.infa.odin.models.erwin.Cache',
	Cardinality = 'com.infa.odin.models.erwin.Cardinality',
	Clustered = 'com.infa.odin.models.erwin.Clustered',
	Code = 'com.infa.odin.models.erwin.Code',
	Complete = 'com.infa.odin.models.erwin.Complete',
	Connection = 'com.infa.odin.models.erwin.Connection',
	Constraint = 'com.infa.odin.models.erwin.Constraint',
	ConstraintName = 'com.infa.odin.models.erwin.ConstraintName',
	CreationTime = 'com.infa.odin.models.erwin.CreationTime',
	Cycle = 'com.infa.odin.models.erwin.Cycle',
	DataMovementComment = 'com.infa.odin.models.erwin.DataMovementComment',
	DataType = 'com.infa.odin.models.erwin.DataType',
	DefaultValue = 'com.infa.odin.models.erwin.DefaultValue',
	DefaultValueName = 'com.infa.odin.models.erwin.DefaultValueName',
	Definition = 'com.infa.odin.models.erwin.Definition',
	DesignLevel = 'com.infa.odin.models.erwin.DesignLevel',
	DimensionalRole = 'com.infa.odin.models.erwin.DimensionalRole',
	DimensionalType = 'com.infa.odin.models.erwin.DimensionalType',
	Exclusive = 'com.infa.odin.models.erwin.Exclusive',
	Expression = 'com.infa.odin.models.erwin.Expression',
	FireOnDelete = 'com.infa.odin.models.erwin.FireOnDelete',
	FireOnInsert = 'com.infa.odin.models.erwin.FireOnInsert',
	FireOnUpdate = 'com.infa.odin.models.erwin.FireOnUpdate',
	Generate = 'com.infa.odin.models.erwin.Generate',
	Group = 'com.infa.odin.models.erwin.Group',
	GroupByClause = 'com.infa.odin.models.erwin.GroupByClause',
	HavingClause = 'com.infa.odin.models.erwin.HavingClause',
	Identifying = 'com.infa.odin.models.erwin.Identifying',
	ImportDate = 'com.infa.odin.models.erwin.ImportDate',
	Importance = 'com.infa.odin.models.erwin.Importance',
	IncrementValue = 'com.infa.odin.models.erwin.IncrementValue',
	InitialValue = 'com.infa.odin.models.erwin.InitialValue',
	Kind = 'com.infa.odin.models.erwin.Kind',
	LastModificationTime = 'com.infa.odin.models.erwin.LastModificationTime',
	Length = 'com.infa.odin.models.erwin.Length',
	LogicalDataType = 'com.infa.odin.models.erwin.LogicalDataType',
	LowerBound = 'com.infa.odin.models.erwin.LowerBound',
	Max = 'com.infa.odin.models.erwin.Max',
	MaxDefinitionLength = 'com.infa.odin.models.erwin.MaxDefinitionLength',
	MaximumValue = 'com.infa.odin.models.erwin.MaximumValue',
	Min = 'com.infa.odin.models.erwin.Min',
	MinimumValue = 'com.infa.odin.models.erwin.MinimumValue',
	ModificationTime = 'com.infa.odin.models.erwin.ModificationTime',
	Modifier = 'com.infa.odin.models.erwin.Modifier',
	NativeDataType = 'com.infa.odin.models.erwin.NativeDataType',
	NativeId = 'com.infa.odin.models.erwin.NativeId',
	NativeLogicalDataType = 'com.infa.odin.models.erwin.NativeLogicalDataType',
	NativeType = 'com.infa.odin.models.erwin.NativeType',
	Notation = 'com.infa.odin.models.erwin.Notation',
	Note = 'com.infa.odin.models.erwin.Note',
	Nullable = 'com.infa.odin.models.erwin.Nullable',
	OnDelete = 'com.infa.odin.models.erwin.OnDelete',
	OnInsert = 'com.infa.odin.models.erwin.OnInsert',
	OnUpdate = 'com.infa.odin.models.erwin.OnUpdate',
	Operation = 'com.infa.odin.models.erwin.Operation',
	OperationDescription = 'com.infa.odin.models.erwin.OperationDescription',
	OrderByClause = 'com.infa.odin.models.erwin.OrderByClause',
	OwnerSchema = 'com.infa.odin.models.erwin.OwnerSchema',
	PhysicalDataType = 'com.infa.odin.models.erwin.PhysicalDataType',
	PhysicalName = 'com.infa.odin.models.erwin.PhysicalName',
	Postcondition = 'com.infa.odin.models.erwin.Postcondition',
	Precondition = 'com.infa.odin.models.erwin.Precondition',
	Scope = 'com.infa.odin.models.erwin.Scope',
	SelectType = 'com.infa.odin.models.erwin.SelectType',
	Sequence = 'com.infa.odin.models.erwin.Sequence',
	SortOrder = 'com.infa.odin.models.erwin.SortOrder',
	Source = 'com.infa.odin.models.erwin.Source',
	StartValue = 'com.infa.odin.models.erwin.StartValue',
	Status = 'com.infa.odin.models.erwin.Status',
	StoreType = 'com.infa.odin.models.erwin.StoreType',
	SystemMajorVersion = 'com.infa.odin.models.erwin.SystemMajorVersion',
	SystemMinorVersion = 'com.infa.odin.models.erwin.SystemMinorVersion',
	SystemReleaseVersion = 'com.infa.odin.models.erwin.SystemReleaseVersion',
	SystemType = 'com.infa.odin.models.erwin.SystemType',
	SystemTypeOld = 'com.infa.odin.models.erwin.SystemTypeOld',
	Table = 'com.infa.odin.models.erwin.Table',
	Text = 'com.infa.odin.models.erwin.Text',
	TriggerType = 'com.infa.odin.models.erwin.TriggerType',
	TypeName = 'com.infa.odin.models.erwin.TypeName',
	Unique = 'com.infa.odin.models.erwin.Unique',
	UniqueKey = 'com.infa.odin.models.erwin.UniqueKey',
	UpperBound = 'com.infa.odin.models.erwin.UpperBound',
	Usage = 'com.infa.odin.models.erwin.Usage',
	UserDataType = 'com.infa.odin.models.erwin.UserDataType',
	Value = 'com.infa.odin.models.erwin.Value',
	ViewStatement = 'com.infa.odin.models.erwin.ViewStatement',
	ViewStatementType = 'com.infa.odin.models.erwin.ViewStatementType',
	ViewType = 'com.infa.odin.models.erwin.ViewType',
	WhereClause = 'com.infa.odin.models.erwin.WhereClause',
}

export enum FileAttr {
	AdditionalMetadata = 'com.infa.odin.models.file.additionalMetadata',
	BlobType = 'com.infa.odin.models.file.blobType',
	ColumnPartitionOrder = 'com.infa.odin.models.file.columnPartitionOrder',
	ContentEncoding = 'com.infa.odin.models.file.contentEncoding',
	ContentLanguage = 'com.infa.odin.models.file.contentLanguage',
	DataTypeLength = 'com.infa.odin.models.file.dataTypeLength',
	ETag = 'com.infa.odin.models.file.eTag',
	FolderType = 'com.infa.odin.models.file.folderType',
	HashScheme = 'com.infa.odin.models.file.hashScheme',
	HashValue = 'com.infa.odin.models.file.hashValue',
	IsAttribute = 'com.infa.odin.models.file.isAttribute',
	IsPartitioned = 'com.infa.odin.models.file.isPartitioned',
	Location = 'com.infa.odin.models.file.location',
	OsType = 'com.infa.odin.models.file.osType',
	Path = 'com.infa.odin.models.file.path',
	Position = 'com.infa.odin.models.file.position',
	PrunedPartition = 'com.infa.odin.models.file.prunedPartition',
	StorageType = 'com.infa.odin.models.file.storageType',
}

export enum FileAzureBlobAttr {
	PublicAccessType = 'com.infa.odin.models.file.azureblob.publicAccessType',
}

export enum FileFlatAttr {
	Delimiter = 'com.infa.odin.models.file.flat.delimiter',
	EscapeCharacter = 'com.infa.odin.models.file.flat.escapeCharacter',
	IsHeaderPresent = 'com.infa.odin.models.file.flat.isHeaderPresent',
	Qualifier = 'com.infa.odin.models.file.flat.qualifier',
	RowDelimiter = 'com.infa.odin.models.file.flat.rowDelimiter',
	RowsSkipped = 'com.infa.odin.models.file.flat.rowsSkipped',
}

export enum FileHierarchicalAttr {
	DataTypeXPath = 'com.infa.odin.models.file.hierarchical.dataTypeXPath',
	FieldXPath = 'com.infa.odin.models.file.hierarchical.fieldXPath',
	GroupName = 'com.infa.odin.models.file.hierarchical.groupName',
	GroupXPath = 'com.infa.odin.models.file.hierarchical.groupXPath',
	SchemaFileLocation = 'com.infa.odin.models.file.hierarchical.schemaFileLocation',
}

export enum FileOfficeAttr {
	Categories = 'com.infa.odin.models.file.office.categories',
	Subject = 'com.infa.odin.models.file.office.subject',
	Tags = 'com.infa.odin.models.file.office.tags',
	Title = 'com.infa.odin.models.file.office.title',
}

export enum GlueAttr {
	CreatedOn = 'com.infa.odin.models.Glue.createdOn',
	Description = 'com.infa.odin.models.Glue.description',
	EndTime = 'com.infa.odin.models.Glue.endTime',
	ExecutionTime = 'com.infa.odin.models.Glue.executionTime',
	GlueVersion = 'com.infa.odin.models.Glue.glueVersion',
	JobName = 'com.infa.odin.models.Glue.jobName',
	Language = 'com.infa.odin.models.Glue.language',
	LastModifiedOn = 'com.infa.odin.models.Glue.lastModifiedOn',
	Role = 'com.infa.odin.models.Glue.role',
	RunStatus = 'com.infa.odin.models.Glue.runStatus',
	StartTime = 'com.infa.odin.models.Glue.startTime',
	Timeout = 'com.infa.odin.models.Glue.timeout',
	TriggerName = 'com.infa.odin.models.Glue.triggerName',
}

export enum GovernanceAttr {
	AliasNames = 'com.infa.ccgf.models.governance.AliasNames',
	AssetID = 'com.infa.ccgf.models.governance.AssetID',
	Automation = 'com.infa.ccgf.models.governance.Automation',
	BusinessLogic = 'com.infa.ccgf.models.governance.BusinessLogic',
	Classification = 'com.infa.ccgf.models.governance.Classification',
	Comments = 'com.infa.ccgf.models.governance.Comments',
	Criticality = 'com.infa.ccgf.models.governance.Criticality',
	DQIntegrationStatus = 'com.infa.ccgf.models.governance.DQIntegrationStatus',
	DataPreviewUri = 'com.infa.ccgf.models.governance.dataPreviewUri',
	Duration = 'com.infa.ccgf.models.governance.Duration',
	EffectiveDate = 'com.infa.ccgf.models.governance.effectiveDate',
	EndDate = 'com.infa.ccgf.models.governance.endDate',
	Examples = 'com.infa.ccgf.models.governance.Examples',
	Exception = 'com.infa.ccgf.models.governance.exception',
	FormatDescription = 'com.infa.ccgf.models.governance.FormatDescription',
	FormatType = 'com.infa.ccgf.models.governance.FormatType',
	Frequency = 'com.infa.ccgf.models.governance.Frequency',
	InterfaceClassification = 'com.infa.ccgf.models.governance.InterfaceClassification',
	IsAutomated = 'com.infa.ccgf.models.governance.isAutomated',
	IsCDE = 'com.infa.ccgf.models.governance.isCDE',
	IsExternal = 'com.infa.ccgf.models.governance.isExternal',
	IsInternal = 'com.infa.ccgf.models.governance.isInternal',
	LongName = 'com.infa.ccgf.models.governance.LongName',
	MaxScore = 'com.infa.ccgf.models.governance.MaxScore',
	MeasuringMethod = 'com.infa.ccgf.models.governance.MeasuringMethod',
	MinScore = 'com.infa.ccgf.models.governance.MinScore',
	OldScore = 'com.infa.ccgf.models.governance.oldScore',
	ProcessType = 'com.infa.ccgf.models.governance.ProcessType',
	ProfileRef = 'com.infa.ccgf.models.governance.profileRef',
	Purpose = 'com.infa.ccgf.models.governance.Purpose',
	Ratings = 'com.infa.ccgf.models.governance.Ratings',
	RuleCount = 'com.infa.ccgf.models.governance.ruleCount',
	RuleMappingId = 'com.infa.ccgf.models.governance.ruleMappingId',
	RuleType = 'com.infa.ccgf.models.governance.RuleType',
	ScannedTime = 'com.infa.ccgf.models.governance.scannedTime',
	ScoreAggregationBuckets = 'com.infa.ccgf.models.governance.ScoreAggregationBuckets',
	SecurityClassification = 'com.infa.ccgf.models.governance.securityClassification',
	SourceSystem = 'com.infa.ccgf.models.governance.SourceSystem',
	StartDate = 'com.infa.ccgf.models.governance.startDate',
	StepType = 'com.infa.ccgf.models.governance.StepType',
	StrategicSource = 'com.infa.ccgf.models.governance.StrategicSource',
	SyncWithTemplate = 'com.infa.ccgf.models.governance.syncWithTemplate',
	SystemType = 'com.infa.ccgf.models.governance.SystemType',
	Target = 'com.infa.ccgf.models.governance.Target',
	TargetSystem = 'com.infa.ccgf.models.governance.TargetSystem',
	TechnicalDescription = 'com.infa.ccgf.models.governance.TechnicalDescription',
	TechnicalRuleReference = 'com.infa.ccgf.models.governance.TechnicalRuleReference',
	Threshold = 'com.infa.ccgf.models.governance.Threshold',
	ThresholdResult = 'com.infa.ccgf.models.governance.thresholdResult',
	TotalCount = 'com.infa.ccgf.models.governance.totalCount',
	TransferFormat = 'com.infa.ccgf.models.governance.TransferFormat',
	TransferMethod = 'com.infa.ccgf.models.governance.TransferMethod',
	Type = 'com.infa.ccgf.models.governance.Type',
	URL = 'com.infa.ccgf.models.governance.URL',
	Value = 'com.infa.ccgf.models.governance.value',
	Viewing = 'com.infa.ccgf.models.governance.Viewing',
}

export enum IICSAttr {
	AffectedSuccessfulRows = 'com.infa.odin.models.IICS.affectedSuccessfulRows',
	CalculationComplexity = 'com.infa.odin.models.IICS.calculationComplexity',
	Content = 'com.infa.odin.models.IICS.content',
	ControlConditions = 'com.infa.odin.models.IICS.controlConditions',
	EndTime = 'com.infa.odin.models.IICS.endTime',
	Expression = 'com.infa.odin.models.IICS.expression',
	FailedRows = 'com.infa.odin.models.IICS.failedRows',
	Folder = 'com.infa.odin.models.IICS.folder',
	HtmlLink = 'com.infa.odin.models.IICS.htmlLink',
	Server = 'com.infa.odin.models.IICS.server',
	SessionFirstErrorMessage = 'com.infa.odin.models.IICS.sessionFirstErrorMessage',
	SessionLastErrorMessage = 'com.infa.odin.models.IICS.sessionLastErrorMessage',
	SessionStatus = 'com.infa.odin.models.IICS.sessionStatus',
	StartTime = 'com.infa.odin.models.IICS.startTime',
	SuccessfulRows = 'com.infa.odin.models.IICS.successfulRows',
	TotalSuccesfulRows = 'com.infa.odin.models.IICS.totalSuccesfulRows',
}

export enum IICSV2Attr {
	AutoSuggest = 'com.infa.odin.models.IICS.V2.autoSuggest',
	CalculationComplexity = 'com.infa.odin.models.IICS.V2.calculationComplexity',
	ControlConditions = 'com.infa.odin.models.IICS.V2.controlConditions',
	CreatedDate = 'com.infa.odin.models.IICS.V2.createdDate',
	Description = 'com.infa.odin.models.IICS.V2.description',
	Enabled = 'com.infa.odin.models.IICS.V2.enabled',
	Expression = 'com.infa.odin.models.IICS.V2.expression',
	Facetable = 'com.infa.odin.models.IICS.V2.facetable',
	FieldParent = 'com.infa.odin.models.IICS.V2.fieldParent',
	FieldType = 'com.infa.odin.models.IICS.V2.fieldType',
	InternalId = 'com.infa.odin.models.IICS.V2.internalId',
	Multiline = 'com.infa.odin.models.IICS.V2.multiline',
	Required = 'com.infa.odin.models.IICS.V2.required',
	Searchable = 'com.infa.odin.models.IICS.V2.searchable',
	UpdatedDate = 'com.infa.odin.models.IICS.V2.updatedDate',
}

export enum IPCAttr {
	AffectedSuccessfulRows = 'com.infa.odin.models.IPC.affectedSuccessfulRows',
	CalculationComplexity = 'com.infa.odin.models.IPC.calculationComplexity',
	Content = 'com.infa.odin.models.IPC.content',
	ControlConditions = 'com.infa.odin.models.IPC.controlConditions',
	EndTime = 'com.infa.odin.models.IPC.endTime',
	Expression = 'com.infa.odin.models.IPC.expression',
	FailedRows = 'com.infa.odin.models.IPC.failedRows',
	Folder = 'com.infa.odin.models.IPC.folder',
	HtmlLink = 'com.infa.odin.models.IPC.htmlLink',
	Server = 'com.infa.odin.models.IPC.server',
	SessionFirstErrorMessage = 'com.infa.odin.models.IPC.sessionFirstErrorMessage',
	SessionLastErrorMessage = 'com.infa.odin.models.IPC.sessionLastErrorMessage',
	SessionStatus = 'com.infa.odin.models.IPC.sessionStatus',
	StartTime = 'com.infa.odin.models.IPC.startTime',
	SuccessfulRows = 'com.infa.odin.models.IPC.successfulRows',
	TotalSuccesfulRows = 'com.infa.odin.models.IPC.totalSuccesfulRows',
}

export enum LakeHouseAttr {
	InputFormat = 'com.infa.odin.models.lakehouse.inputFormat',
	LastAccess = 'com.infa.odin.models.lakehouse.lastAccess',
	MinReaderVersion = 'com.infa.odin.models.lakehouse.minReaderVersion',
	MinWriterVersion = 'com.infa.odin.models.lakehouse.minWriterVersion',
	NumFiles = 'com.infa.odin.models.lakehouse.numFiles',
	OutputFormat = 'com.infa.odin.models.lakehouse.outputFormat',
	Path = 'com.infa.odin.models.lakehouse.path',
	SerdeLibrary = 'com.infa.odin.models.lakehouse.serdeLibrary',
	SizeInBytes = 'com.infa.odin.models.lakehouse.sizeInBytes',
	StorageProperties = 'com.infa.odin.models.lakehouse.storageProperties',
	TableId = 'com.infa.odin.models.lakehouse.tableId',
	TableProperties = 'com.infa.odin.models.lakehouse.tableProperties',
	TableProvider = 'com.infa.odin.models.lakehouse.tableProvider',
	TableType = 'com.infa.odin.models.lakehouse.tableType',
	ViewCatalogAndNamespace = 'com.infa.odin.models.lakehouse.viewCatalogAndNamespace',
	ViewOriginalText = 'com.infa.odin.models.lakehouse.viewOriginalText',
}

export enum LookerAttr {
	Aggregation = 'com.infa.odin.models.looker.Aggregation',
	Author = 'com.infa.odin.models.looker.Author',
	CreationTime = 'com.infa.odin.models.looker.CreationTime',
	DataType = 'com.infa.odin.models.looker.DataType',
	Expression = 'com.infa.odin.models.looker.Expression',
	Hidden = 'com.infa.odin.models.looker.Hidden',
	ImportDate = 'com.infa.odin.models.looker.ImportDate',
	LastModificationTime = 'com.infa.odin.models.looker.LastModificationTime',
	ModificationTime = 'com.infa.odin.models.looker.ModificationTime',
	Modifier = 'com.infa.odin.models.looker.Modifier',
	NativeId = 'com.infa.odin.models.looker.NativeId',
	NativeType = 'com.infa.odin.models.looker.NativeType',
	PhysicalName = 'com.infa.odin.models.looker.PhysicalName',
	StoreType = 'com.infa.odin.models.looker.StoreType',
	SystemMajorVersion = 'com.infa.odin.models.looker.SystemMajorVersion',
	SystemMinorVersion = 'com.infa.odin.models.looker.SystemMinorVersion',
	SystemReleaseVersion = 'com.infa.odin.models.looker.SystemReleaseVersion',
	SystemType = 'com.infa.odin.models.looker.SystemType',
	SystemTypeOld = 'com.infa.odin.models.looker.SystemTypeOld',
	Type = 'com.infa.odin.models.looker.Type',
	UIId = 'com.infa.odin.models.looker.UIId',
	Value = 'com.infa.odin.models.looker.Value',
}

export enum MarketPlaceAttr {
	AccessGrantedOn = 'com.infa.cdmp.marketplace.accessGrantedOn',
	AdminSettingNamespace = 'com.infa.cdmp.marketplace.adminSettingNamespace',
	AdminSettingValue = 'com.infa.cdmp.marketplace.adminSettingValue',
	AssetLocation = 'com.infa.cdmp.marketplace.assetLocation',
	AssetLocationDescription = 'com.infa.cdmp.marketplace.assetLocationDescription',
	AssetTypeStatus = 'com.infa.cdmp.marketplace.AssetTypeStatus',
	BatchFileRecordContent = 'com.infa.cdmp.marketplace.BatchFileRecordContent',
	BatchFileRecordIndex = 'com.infa.cdmp.marketplace.BatchFileRecordIndex',
	BatchId = 'com.infa.cdmp.marketplace.BatchId',
	BatchJobExecutionStatus = 'com.infa.cdmp.marketplace.BatchJobExecutionStatus',
	CategoryEffectiveStatus = 'com.infa.cdmp.marketplace.CategoryEffectiveStatus',
	CategoryStatus = 'com.infa.cdmp.marketplace.CategoryStatus',
	Code = 'com.infa.cdmp.marketplace.code',
	Color = 'com.infa.cdmp.marketplace.color',
	Comment = 'com.infa.cdmp.marketplace.comment',
	ComponentType = 'com.infa.cdmp.marketplace.ComponentType',
	ConsumerAccessStatus = 'com.infa.cdmp.marketplace.ConsumerAccessStatus',
	CostCenter = 'com.infa.cdmp.marketplace.costCenter',
	DataAssetLifeCycleStatus = 'com.infa.cdmp.marketplace.DataAssetLifeCycleStatus',
	DataCollectionStatus = 'com.infa.cdmp.marketplace.DataCollectionStatus',
	DataElementStatus = 'com.infa.cdmp.marketplace.DataElementStatus',
	DefaultPhysicalLocation = 'com.infa.cdmp.marketplace.defaultPhysicalLocation',
	DeliveryRequests = 'com.infa.cdmp.marketplace.deliveryRequests',
	DeliveryType = 'com.infa.cdmp.marketplace.DeliveryType',
	DescriptiveSource = 'com.infa.cdmp.marketplace.descriptiveSource',
	FieldValueChanges = 'com.infa.cdmp.marketplace.fieldValueChanges',
	InitializedOn = 'com.infa.cdmp.marketplace.initializedOn',
	Initials = 'com.infa.cdmp.marketplace.initials',
	IntegrationSourceStatus = 'com.infa.cdmp.marketplace.IntegrationSourceStatus',
	IntegrationSourceType = 'com.infa.cdmp.marketplace.IntegrationSourceType',
	IsAutomated = 'com.infa.cdmp.marketplace.isAutomated',
	IsDefault = 'com.infa.cdmp.marketplace.isDefault',
	IsGroup = 'com.infa.cdmp.marketplace.isGroup',
	JobEndTime = 'com.infa.cdmp.marketplace.JobEndTime',
	JobExitCode = 'com.infa.cdmp.marketplace.JobExitCode',
	JobExitMessage = 'com.infa.cdmp.marketplace.JobExitMessage',
	JobFileType = 'com.infa.cdmp.marketplace.JobFileType',
	JobKey = 'com.infa.cdmp.marketplace.JobKey',
	JobName = 'com.infa.cdmp.marketplace.JobName',
	JobStartTime = 'com.infa.cdmp.marketplace.JobStartTime',
	Justification = 'com.infa.cdmp.marketplace.justification',
	LifeCycleCommentStatus = 'com.infa.cdmp.marketplace.lifeCycleCommentStatus',
	MetricConfigStatus = 'com.infa.cdmp.marketplace.MetricConfigStatus',
	MetricValue = 'com.infa.cdmp.marketplace.metricValue',
	ObjectId = 'com.infa.cdmp.marketplace.objectId',
	ObjectType = 'com.infa.cdmp.marketplace.objectType',
	OrderStatus = 'com.infa.cdmp.marketplace.OrderStatus',
	PayloadContent = 'com.infa.cdmp.marketplace.payloadContent',
	PhysicalLocation = 'com.infa.cdmp.marketplace.physicalLocation',
	Reference = 'com.infa.cdmp.marketplace.reference',
	ReferenceLink = 'com.infa.cdmp.marketplace.referenceLink',
	RequestNewDataCollectionStatus = 'com.infa.cdmp.marketplace.RequestNewDataCollectionStatus',
	RequestedProvisionedTargets = 'com.infa.cdmp.marketplace.requestedProvisionedTargets',
	SerializedContext = 'com.infa.cdmp.marketplace.SerializedContext',
	Source = 'com.infa.cdmp.marketplace.source',
	Status = 'com.infa.cdmp.marketplace.Status',
	SubReference = 'com.infa.cdmp.marketplace.subReference',
	TargetSystemReference = 'com.infa.cdmp.marketplace.targetSystemReference',
	TechnicalAssetName = 'com.infa.cdmp.marketplace.technicalAssetName',
	TechnicalName = 'com.infa.cdmp.marketplace.technicalName',
	TechnicalType = 'com.infa.cdmp.marketplace.technicalType',
	TermsOfUseAcknowledge = 'com.infa.cdmp.marketplace.TermsOfUseAcknowledge',
	TermsOfUseSnapshotGeneralTermsOfUse = 'com.infa.cdmp.marketplace.TermsOfUseSnapshotGeneralTermsOfUse',
	TermsOfUseSnapshotTermsOfUseHash = 'com.infa.cdmp.marketplace.TermsOfUseSnapshotTermsOfUseHash',
	TermsOfUseSnapshotTermsOfUseId = 'com.infa.cdmp.marketplace.TermsOfUseSnapshotTermsOfUseId',
	TermsOfUseSnapshotTermsOfUseRefId = 'com.infa.cdmp.marketplace.TermsOfUseSnapshotTermsOfUseRefId',
	TermsOfUseStatus = 'com.infa.cdmp.marketplace.TermsOfUseStatus',
	TermsOfUseType = 'com.infa.cdmp.marketplace.TermsOfUseType',
	Type = 'com.infa.cdmp.marketplace.type',
	UnprocessedFileContent = 'com.infa.cdmp.marketplace.UnprocessedFileContent',
	UsageContextStatus = 'com.infa.cdmp.marketplace.UsageContextStatus',
	UserId = 'com.infa.cdmp.marketplace.userId',
	VariantCollections = 'com.infa.cdmp.marketplace.variantCollections',
	VariantOfCollections = 'com.infa.cdmp.marketplace.variantOfCollections',
	Version = 'com.infa.cdmp.marketplace.version',
}

export enum MessagingAttr {
	InferredFieldType = 'com.infa.odin.models.messaging.inferredFieldType',
	SchemaInferenceSource = 'com.infa.odin.models.messaging.schemaInferenceSource',
}

export enum MessagingKafkaAttr {
	BrokerCount = 'com.infa.odin.models.messaging.kafka.brokerCount',
	CleanupPolicy = 'com.infa.odin.models.messaging.kafka.cleanupPolicy',
	CompressionType = 'com.infa.odin.models.messaging.kafka.compressionType',
	Distribution = 'com.infa.odin.models.messaging.kafka.distribution',
	MaxMessageSize = 'com.infa.odin.models.messaging.kafka.maxMessageSize',
	MinInsyncReplicas = 'com.infa.odin.models.messaging.kafka.minInsyncReplicas',
	PartitionCount = 'com.infa.odin.models.messaging.kafka.partitionCount',
	RetentionBytes = 'com.infa.odin.models.messaging.kafka.retentionBytes',
	RetentionDuration = 'com.infa.odin.models.messaging.kafka.retentionDuration',
}

export enum MstrAttr {
	Author = 'com.infa.odin.models.mstr.Author',
	Connection = 'com.infa.odin.models.mstr.Connection',
	Constraint = 'com.infa.odin.models.mstr.Constraint',
	CreationDate = 'com.infa.odin.models.mstr.CreationDate',
	CreationTime = 'com.infa.odin.models.mstr.CreationTime',
	Creator = 'com.infa.odin.models.mstr.Creator',
	DefaultAggregation = 'com.infa.odin.models.mstr.DefaultAggregation',
	Definition = 'com.infa.odin.models.mstr.Definition',
	DesignLevel = 'com.infa.odin.models.mstr.DesignLevel',
	Expression = 'com.infa.odin.models.mstr.Expression',
	ExpressionDescription = 'com.infa.odin.models.mstr.ExpressionDescription',
	ExternalId = 'com.infa.odin.models.mstr.ExternalId',
	Hidden = 'com.infa.odin.models.mstr.Hidden',
	Hide = 'com.infa.odin.models.mstr.Hide',
	ImportDate = 'com.infa.odin.models.mstr.ImportDate',
	InitialValue = 'com.infa.odin.models.mstr.InitialValue',
	LastModificationTime = 'com.infa.odin.models.mstr.LastModificationTime',
	LeftMultiplicity = 'com.infa.odin.models.mstr.LeftMultiplicity',
	LogicalDataType = 'com.infa.odin.models.mstr.LogicalDataType',
	LongDescription = 'com.infa.odin.models.mstr.LongDescription',
	ModificationDate = 'com.infa.odin.models.mstr.ModificationDate',
	ModificationTime = 'com.infa.odin.models.mstr.ModificationTime',
	Modifier = 'com.infa.odin.models.mstr.Modifier',
	MultipleSelection = 'com.infa.odin.models.mstr.MultipleSelection',
	NativeId = 'com.infa.odin.models.mstr.NativeId',
	NativeType = 'com.infa.odin.models.mstr.NativeType',
	Nullable = 'com.infa.odin.models.mstr.Nullable',
	Operation = 'com.infa.odin.models.mstr.Operation',
	Optional = 'com.infa.odin.models.mstr.Optional',
	OriginalName = 'com.infa.odin.models.mstr.OriginalName',
	PhysicalDataType = 'com.infa.odin.models.mstr.PhysicalDataType',
	PhysicalName = 'com.infa.odin.models.mstr.PhysicalName',
	Question = 'com.infa.odin.models.mstr.Question',
	RightMultiplicity = 'com.infa.odin.models.mstr.RightMultiplicity',
	Role = 'com.infa.odin.models.mstr.Role',
	SQLDefinition = 'com.infa.odin.models.mstr.SQLDefinition',
	Sort = 'com.infa.odin.models.mstr.Sort',
	StoreType = 'com.infa.odin.models.mstr.StoreType',
	SystemMajorVersion = 'com.infa.odin.models.mstr.SystemMajorVersion',
	SystemMinorVersion = 'com.infa.odin.models.mstr.SystemMinorVersion',
	SystemReleaseVersion = 'com.infa.odin.models.mstr.SystemReleaseVersion',
	SystemType = 'com.infa.odin.models.mstr.SystemType',
	SystemTypeOld = 'com.infa.odin.models.mstr.SystemTypeOld',
	Text = 'com.infa.odin.models.mstr.Text',
	Type = 'com.infa.odin.models.mstr.Type',
	TypeLength = 'com.infa.odin.models.mstr.TypeLength',
	TypeName = 'com.infa.odin.models.mstr.TypeName',
	TypeScale = 'com.infa.odin.models.mstr.TypeScale',
	URLId = 'com.infa.odin.models.mstr.URLId',
	Usage = 'com.infa.odin.models.mstr.Usage',
	Value = 'com.infa.odin.models.mstr.Value',
}

export enum PowerBICloudAttr {
	AddRowsApiEnabled = 'com.infa.odin.models.PowerBI.Cloud.AddRowsApiEnabled',
	CalculationComplexity = 'com.infa.odin.models.PowerBI.Cloud.calculationComplexity',
	CapacityId = 'com.infa.odin.models.PowerBI.Cloud.CapacityId',
	ColSpan = 'com.infa.odin.models.PowerBI.Cloud.ColSpan',
	ConfiguredBy = 'com.infa.odin.models.PowerBI.Cloud.ConfiguredBy',
	ContentProviderType = 'com.infa.odin.models.PowerBI.Cloud.ContentProviderType',
	ControlConditions = 'com.infa.odin.models.PowerBI.Cloud.controlConditions',
	CreateReportEmbedUrl = 'com.infa.odin.models.PowerBI.Cloud.CreateReportEmbedUrl',
	CreatedBy = 'com.infa.odin.models.PowerBI.Cloud.CreatedBy',
	CreatedDate = 'com.infa.odin.models.PowerBI.Cloud.CreatedDate',
	CreatedDateTime = 'com.infa.odin.models.PowerBI.Cloud.CreatedDateTime',
	DataClassification = 'com.infa.odin.models.PowerBI.Cloud.DataClassification',
	DatasetId = 'com.infa.odin.models.PowerBI.Cloud.DatasetId',
	Description = 'com.infa.odin.models.PowerBI.Cloud.Description',
	DisplayName = 'com.infa.odin.models.PowerBI.Cloud.DisplayName',
	EmbedData = 'com.infa.odin.models.PowerBI.Cloud.EmbedData',
	EmbedUrl = 'com.infa.odin.models.PowerBI.Cloud.EmbedUrl',
	Expression = 'com.infa.odin.models.PowerBI.Cloud.expression',
	HtmlLink = 'com.infa.odin.models.PowerBI.Cloud.htmlLink',
	Id = 'com.infa.odin.models.PowerBI.Cloud.Id',
	IsEffectiveIdentityRequired = 'com.infa.odin.models.PowerBI.Cloud.IsEffectiveIdentityRequired',
	IsEffectiveIdentityRolesRequired = 'com.infa.odin.models.PowerBI.Cloud.IsEffectiveIdentityRolesRequired',
	IsOnDedicatedCapacity = 'com.infa.odin.models.PowerBI.Cloud.IsOnDedicatedCapacity',
	IsOnPermGatewayRequired = 'com.infa.odin.models.PowerBI.Cloud.IsOnPermGatewayRequired',
	IsReadOnly = 'com.infa.odin.models.PowerBI.Cloud.IsReadOnly',
	IsRefreshable = 'com.infa.odin.models.PowerBI.Cloud.IsRefreshable',
	ModifiedBy = 'com.infa.odin.models.PowerBI.Cloud.ModifiedBy',
	ModifiedDateTime = 'com.infa.odin.models.PowerBI.Cloud.ModifiedDateTime',
	Name = 'com.infa.odin.models.PowerBI.Cloud.Name',
	QnaEmbedUrl = 'com.infa.odin.models.PowerBI.Cloud.QnaEmbedUrl',
	ReportId = 'com.infa.odin.models.PowerBI.Cloud.ReportId',
	ReportType = 'com.infa.odin.models.PowerBI.Cloud.ReportType',
	RetrievalState = 'com.infa.odin.models.PowerBI.Cloud.RetrievalState',
	RowSpan = 'com.infa.odin.models.PowerBI.Cloud.RowSpan',
	SchemaMayNotBeUpToDate = 'com.infa.odin.models.PowerBI.Cloud.SchemaMayNotBeUpToDate',
	SchemaRetrievalError = 'com.infa.odin.models.PowerBI.Cloud.SchemaRetrievalError',
	State = 'com.infa.odin.models.PowerBI.Cloud.State',
	Subtitle = 'com.infa.odin.models.PowerBI.Cloud.Subtitle',
	Title = 'com.infa.odin.models.PowerBI.Cloud.Title',
	Type = 'com.infa.odin.models.PowerBI.Cloud.Type',
	Url = 'com.infa.odin.models.PowerBI.Cloud.url',
}

export enum PurviewAttr {
	CollectionProvisioningState = 'com.infa.odin.models.Purview.CollectionProvisioningState',
}

export enum QlikSenseAttr {
	Author = 'com.infa.odin.models.qlikSense.Author',
	ConnectionInformation = 'com.infa.odin.models.qlikSense.ConnectionInformation',
	Constraint = 'com.infa.odin.models.qlikSense.Constraint',
	CreationTime = 'com.infa.odin.models.qlikSense.CreationTime',
	Definition = 'com.infa.odin.models.qlikSense.Definition',
	DesignLevel = 'com.infa.odin.models.qlikSense.DesignLevel',
	Expression = 'com.infa.odin.models.qlikSense.Expression',
	ImportDate = 'com.infa.odin.models.qlikSense.ImportDate',
	InitialValue = 'com.infa.odin.models.qlikSense.InitialValue',
	LastModificationTime = 'com.infa.odin.models.qlikSense.LastModificationTime',
	LogicalDataType = 'com.infa.odin.models.qlikSense.LogicalDataType',
	Modifier = 'com.infa.odin.models.qlikSense.Modifier',
	NativeId = 'com.infa.odin.models.qlikSense.NativeId',
	NativeType = 'com.infa.odin.models.qlikSense.NativeType',
	Nullable = 'com.infa.odin.models.qlikSense.Nullable',
	PhysicalDataType = 'com.infa.odin.models.qlikSense.PhysicalDataType',
	PhysicalName = 'com.infa.odin.models.qlikSense.PhysicalName',
	Script = 'com.infa.odin.models.qlikSense.Script',
	StoreType = 'com.infa.odin.models.qlikSense.StoreType',
	StreamName = 'com.infa.odin.models.qlikSense.StreamName',
	SystemMajorVersion = 'com.infa.odin.models.qlikSense.SystemMajorVersion',
	SystemMinorVersion = 'com.infa.odin.models.qlikSense.SystemMinorVersion',
	SystemReleaseVersion = 'com.infa.odin.models.qlikSense.SystemReleaseVersion',
	SystemType = 'com.infa.odin.models.qlikSense.SystemType',
	TypeLength = 'com.infa.odin.models.qlikSense.TypeLength',
	TypeName = 'com.infa.odin.models.qlikSense.TypeName',
	TypeScale = 'com.infa.odin.models.qlikSense.TypeScale',
	Value = 'com.infa.odin.models.qlikSense.Value',
}

export enum QlikViewAttr {
	Author = 'com.infa.odin.models.qlikView.Author',
	Constraint = 'com.infa.odin.models.qlikView.Constraint',
	CreationTime = 'com.infa.odin.models.qlikView.CreationTime',
	Definition = 'com.infa.odin.models.qlikView.Definition',
	DesignLevel = 'com.infa.odin.models.qlikView.DesignLevel',
	Expression = 'com.infa.odin.models.qlikView.Expression',
	ImportDate = 'com.infa.odin.models.qlikView.ImportDate',
	InitialValue = 'com.infa.odin.models.qlikView.InitialValue',
	LastModificationTime = 'com.infa.odin.models.qlikView.LastModificationTime',
	LogicalDataType = 'com.infa.odin.models.qlikView.LogicalDataType',
	Modifier = 'com.infa.odin.models.qlikView.Modifier',
	NativeId = 'com.infa.odin.models.qlikView.NativeId',
	NativeType = 'com.infa.odin.models.qlikView.NativeType',
	Nullable = 'com.infa.odin.models.qlikView.Nullable',
	PhysicalDataType = 'com.infa.odin.models.qlikView.PhysicalDataType',
	PhysicalName = 'com.infa.odin.models.qlikView.PhysicalName',
	Script = 'com.infa.odin.models.qlikView.Script',
	StoreType = 'com.infa.odin.models.qlikView.StoreType',
	SystemMajorVersion = 'com.infa.odin.models.qlikView.SystemMajorVersion',
	SystemMinorVersion = 'com.infa.odin.models.qlikView.SystemMinorVersion',
	SystemReleaseVersion = 'com.infa.odin.models.qlikView.SystemReleaseVersion',
	SystemType = 'com.infa.odin.models.qlikView.SystemType',
	TypeLength = 'com.infa.odin.models.qlikView.TypeLength',
	TypeName = 'com.infa.odin.models.qlikView.TypeName',
	TypeScale = 'com.infa.odin.models.qlikView.TypeScale',
	Value = 'com.infa.odin.models.qlikView.Value',
}

export enum RelationalAttr {
	CalculationComplexity = 'com.infa.odin.models.relational.calculationComplexity',
	CallComment = 'com.infa.odin.models.relational.callComment',
	CallId = 'com.infa.odin.models.relational.callId',
	CallStackTrace = 'com.infa.odin.models.relational.callStackTrace',
	Comment = 'com.infa.odin.models.relational.Comment',
	ControlConditions = 'com.infa.odin.models.relational.controlConditions',
	Datatype = 'com.infa.odin.models.relational.Datatype',
	DatatypeLength = 'com.infa.odin.models.relational.DatatypeLength',
	DatatypeScale = 'com.infa.odin.models.relational.DatatypeScale',
	ErrorMessage = 'com.infa.odin.models.relational.errorMessage',
	Expression = 'com.infa.odin.models.relational.expression',
	HtmlLink = 'com.infa.odin.models.relational.htmlLink',
	Location = 'com.infa.odin.models.relational.Location',
	Nullable = 'com.infa.odin.models.relational.Nullable',
	NumberOfRows = 'com.infa.odin.models.relational.NumberOfRows',
	Owner = 'com.infa.odin.models.relational.Owner',
	PartitionBy = 'com.infa.odin.models.relational.PartitionBy',
	Partitioned = 'com.infa.odin.models.relational.Partitioned',
	Position = 'com.infa.odin.models.relational.Position',
	PrimaryKeyColumn = 'com.infa.odin.models.relational.PrimaryKeyColumn',
	ProductName = 'com.infa.odin.models.relational.ProductName',
	ProductVersion = 'com.infa.odin.models.relational.ProductVersion',
	Provider = 'com.infa.odin.models.relational.Provider',
	SourceCommentText = 'com.infa.odin.models.relational.sourceCommentText',
	SourceCompleteText = 'com.infa.odin.models.relational.sourceCompleteText',
	SourceStatementText = 'com.infa.odin.models.relational.sourceStatementText',
	StatementCommentText = 'com.infa.odin.models.relational.statementCommentText',
	TableType = 'com.infa.odin.models.relational.TableType',
	TagAllowedValues = 'com.infa.odin.models.relational.TagAllowedValues',
	TagValue = 'com.infa.odin.models.relational.TagValue',
	ViewType = 'com.infa.odin.models.relational.ViewType',
}

export enum SAPBOAttr {
	AllowMultipleValues = 'com.infa.odin.models.SAPBO.AllowMultipleValues',
	Author = 'com.infa.odin.models.SAPBO.Author',
	Connection = 'com.infa.odin.models.SAPBO.Connection',
	CreationTime = 'com.infa.odin.models.SAPBO.CreationTime',
	DataSource = 'com.infa.odin.models.SAPBO.DataSource',
	DefaultAggregation = 'com.infa.odin.models.SAPBO.DefaultAggregation',
	DefaultValues = 'com.infa.odin.models.SAPBO.DefaultValues',
	DesignLevel = 'com.infa.odin.models.SAPBO.DesignLevel',
	Expression = 'com.infa.odin.models.SAPBO.Expression',
	ExternalId = 'com.infa.odin.models.SAPBO.ExternalId',
	Hide = 'com.infa.odin.models.SAPBO.Hide',
	ImportDate = 'com.infa.odin.models.SAPBO.ImportDate',
	InitialValue = 'com.infa.odin.models.SAPBO.InitialValue',
	Keywords = 'com.infa.odin.models.SAPBO.Keywords',
	LastModificationTime = 'com.infa.odin.models.SAPBO.LastModificationTime',
	LastRefreshDate = 'com.infa.odin.models.SAPBO.LastRefreshDate',
	LastRefreshDuration = 'com.infa.odin.models.SAPBO.LastRefreshDuration',
	LeftMultiplicity = 'com.infa.odin.models.SAPBO.LeftMultiplicity',
	Locale = 'com.infa.odin.models.SAPBO.Locale',
	ModificationTime = 'com.infa.odin.models.SAPBO.ModificationTime',
	Modifier = 'com.infa.odin.models.SAPBO.Modifier',
	MultipleSelection = 'com.infa.odin.models.SAPBO.MultipleSelection',
	NativeId = 'com.infa.odin.models.SAPBO.NativeId',
	NativeType = 'com.infa.odin.models.SAPBO.NativeType',
	Nullable = 'com.infa.odin.models.SAPBO.Nullable',
	Optional = 'com.infa.odin.models.SAPBO.Optional',
	PhysicalName = 'com.infa.odin.models.SAPBO.PhysicalName',
	PromptText = 'com.infa.odin.models.SAPBO.PromptText',
	Question = 'com.infa.odin.models.SAPBO.Question',
	Retrieveduplicaterows = 'com.infa.odin.models.SAPBO.Retrieveduplicaterows',
	RightMultiplicity = 'com.infa.odin.models.SAPBO.RightMultiplicity',
	Role = 'com.infa.odin.models.SAPBO.Role',
	Select = 'com.infa.odin.models.SAPBO.Select',
	Sort = 'com.infa.odin.models.SAPBO.Sort',
	SourceTable = 'com.infa.odin.models.SAPBO.SourceTable',
	Statement = 'com.infa.odin.models.SAPBO.Statement',
	Stereotype = 'com.infa.odin.models.SAPBO.Stereotype',
	StoreType = 'com.infa.odin.models.SAPBO.StoreType',
	Subject = 'com.infa.odin.models.SAPBO.Subject',
	SystemMajorVersion = 'com.infa.odin.models.SAPBO.SystemMajorVersion',
	SystemMinorVersion = 'com.infa.odin.models.SAPBO.SystemMinorVersion',
	SystemReleaseVersion = 'com.infa.odin.models.SAPBO.SystemReleaseVersion',
	SystemType = 'com.infa.odin.models.SAPBO.SystemType',
	SystemTypeOld = 'com.infa.odin.models.SAPBO.SystemTypeOld',
	Title = 'com.infa.odin.models.SAPBO.Title',
	Type = 'com.infa.odin.models.SAPBO.Type',
	TypeLength = 'com.infa.odin.models.SAPBO.TypeLength',
	TypeName = 'com.infa.odin.models.SAPBO.TypeName',
	TypeScale = 'com.infa.odin.models.SAPBO.TypeScale',
	UIId = 'com.infa.odin.models.SAPBO.UIId',
	UniqueKey = 'com.infa.odin.models.SAPBO.UniqueKey',
	Usage = 'com.infa.odin.models.SAPBO.Usage',
	Value = 'com.infa.odin.models.SAPBO.Value',
	Where = 'com.infa.odin.models.SAPBO.Where',
}

export enum SAPBWAttr {
	AggregationType = 'com.infa.odin.models.warehouse.sapbw.AggregationType',
	ApplicationComponent = 'com.infa.odin.models.warehouse.sapbw.ApplicationComponent',
	CreatedBy = 'com.infa.odin.models.warehouse.sapbw.createdBy',
	CreatedTime = 'com.infa.odin.models.warehouse.sapbw.createdTime',
	Datatype = 'com.infa.odin.models.warehouse.sapbw.Datatype',
	DatatypeDescription = 'com.infa.odin.models.warehouse.sapbw.DatatypeDescription',
	DatatypeInternalLength = 'com.infa.odin.models.warehouse.sapbw.DatatypeInternalLength',
	DatatypeLength = 'com.infa.odin.models.warehouse.sapbw.DatatypeLength',
	DatatypeScale = 'com.infa.odin.models.warehouse.sapbw.DatatypeScale',
	ExternalView = 'com.infa.odin.models.warehouse.sapbw.ExternalView',
	Filter = 'com.infa.odin.models.warehouse.sapbw.Filter',
	HostSystem = 'com.infa.odin.models.warehouse.sapbw.HostSystem',
	InfoObjectBase = 'com.infa.odin.models.warehouse.sapbw.InfoObjectBase',
	JoinType = 'com.infa.odin.models.warehouse.sapbw.JoinType',
	KeyFlag = 'com.infa.odin.models.warehouse.sapbw.KeyFlag',
	LastExecutionTime = 'com.infa.odin.models.warehouse.sapbw.LastExecutionTime',
	LastRefreshTime = 'com.infa.odin.models.warehouse.sapbw.LastRefreshTime',
	LinkedInfoArea = 'com.infa.odin.models.warehouse.sapbw.LinkedInfoArea',
	MultiDimension = 'com.infa.odin.models.warehouse.sapbw.MultiDimension',
	NativeId = 'com.infa.odin.models.warehouse.sapbw.NativeId',
	Owner = 'com.infa.odin.models.warehouse.sapbw.Owner',
	Position = 'com.infa.odin.models.warehouse.sapbw.Position',
	RFCDestination = 'com.infa.odin.models.warehouse.sapbw.RFCDestination',
	RFCUser = 'com.infa.odin.models.warehouse.sapbw.RFCUser',
	Type = 'com.infa.odin.models.warehouse.sapbw.Type',
	UpdateMode = 'com.infa.odin.models.warehouse.sapbw.UpdateMode',
	Value = 'com.infa.odin.models.warehouse.sapbw.Value',
	Version = 'com.infa.odin.models.warehouse.sapbw.Version',
}

export enum SAPBWHanaAttr {
	AggregationType = 'com.infa.odin.models.warehouse.sapbwhana.AggregationType',
	ApplicationComponent = 'com.infa.odin.models.warehouse.sapbwhana.ApplicationComponent',
	AttributeOnly = 'com.infa.odin.models.warehouse.sapbwhana.AttributeOnly',
	Authorization = 'com.infa.odin.models.warehouse.sapbwhana.Authorization',
	Calculated = 'com.infa.odin.models.warehouse.sapbwhana.Calculated',
	CreatedBy = 'com.infa.odin.models.warehouse.sapbwhana.createdBy',
	CreatedTime = 'com.infa.odin.models.warehouse.sapbwhana.createdTime',
	Datatype = 'com.infa.odin.models.warehouse.sapbwhana.Datatype',
	DatatypeDescription = 'com.infa.odin.models.warehouse.sapbwhana.DatatypeDescription',
	DatatypeInternalLength = 'com.infa.odin.models.warehouse.sapbwhana.DatatypeInternalLength',
	DatatypeLength = 'com.infa.odin.models.warehouse.sapbwhana.DatatypeLength',
	DatatypeScale = 'com.infa.odin.models.warehouse.sapbwhana.DatatypeScale',
	ExternalView = 'com.infa.odin.models.warehouse.sapbwhana.ExternalView',
	Filter = 'com.infa.odin.models.warehouse.sapbwhana.Filter',
	Hierarchies = 'com.infa.odin.models.warehouse.sapbwhana.Hierarchies',
	HostSystem = 'com.infa.odin.models.warehouse.sapbwhana.HostSystem',
	InfoObjectBase = 'com.infa.odin.models.warehouse.sapbwhana.InfoObjectBase',
	JoinType = 'com.infa.odin.models.warehouse.sapbwhana.JoinType',
	KeyFlag = 'com.infa.odin.models.warehouse.sapbwhana.KeyFlag',
	LastExecutionTime = 'com.infa.odin.models.warehouse.sapbwhana.LastExecutionTime',
	LastRefreshTime = 'com.infa.odin.models.warehouse.sapbwhana.LastRefreshTime',
	LinkedInfoArea = 'com.infa.odin.models.warehouse.sapbwhana.LinkedInfoArea',
	LogicalSystem = 'com.infa.odin.models.warehouse.sapbwhana.LogicalSystem',
	MasterData = 'com.infa.odin.models.warehouse.sapbwhana.MasterData',
	MasterDataUpdate = 'com.infa.odin.models.warehouse.sapbwhana.MasterDataUpdate',
	MultiDimension = 'com.infa.odin.models.warehouse.sapbwhana.MultiDimension',
	NativeId = 'com.infa.odin.models.warehouse.sapbwhana.NativeId',
	Owner = 'com.infa.odin.models.warehouse.sapbwhana.Owner',
	Position = 'com.infa.odin.models.warehouse.sapbwhana.Position',
	RFCDestination = 'com.infa.odin.models.warehouse.sapbwhana.RFCDestination',
	RFCUser = 'com.infa.odin.models.warehouse.sapbwhana.RFCUser',
	Semantics = 'com.infa.odin.models.warehouse.sapbwhana.Semantics',
	Texts = 'com.infa.odin.models.warehouse.sapbwhana.Texts',
	Type = 'com.infa.odin.models.warehouse.sapbwhana.Type',
	UpdateMode = 'com.infa.odin.models.warehouse.sapbwhana.UpdateMode',
	UseAsInfoProvider = 'com.infa.odin.models.warehouse.sapbwhana.UseAsInfoProvider',
	Value = 'com.infa.odin.models.warehouse.sapbwhana.Value',
	Version = 'com.infa.odin.models.warehouse.sapbwhana.Version',
}

export enum SAPS4HanaAttr {
	ApplicationComponent = 'com.infa.odin.models.application.saps4hana.ApplicationComponent',
	CDSViewNameInHana = 'com.infa.odin.models.application.saps4hana.CDSViewNameInHana',
	CheckTable = 'com.infa.odin.models.application.saps4hana.CheckTable',
	Clstype = 'com.infa.odin.models.application.saps4hana.Clstype',
	Condition = 'com.infa.odin.models.application.saps4hana.Condition',
	ConversionRoutine = 'com.infa.odin.models.application.saps4hana.ConversionRoutine',
	CreatedBy = 'com.infa.odin.models.application.saps4hana.CreatedBy',
	CreatedTime = 'com.infa.odin.models.application.saps4hana.CreatedTime',
	DatatypeInternalLength = 'com.infa.odin.models.application.saps4hana.DatatypeInternalLength',
	DatatypeInternalType = 'com.infa.odin.models.application.saps4hana.DatatypeInternalType',
	Dynpro = 'com.infa.odin.models.application.saps4hana.Dynpro',
	ExMethod = 'com.infa.odin.models.application.saps4hana.ExMethod',
	ExStruct = 'com.infa.odin.models.application.saps4hana.ExStruct',
	Exposure = 'com.infa.odin.models.application.saps4hana.Exposure',
	FGroup = 'com.infa.odin.models.application.saps4hana.FGroup',
	FMode = 'com.infa.odin.models.application.saps4hana.FMode',
	FieldDataDomain = 'com.infa.odin.models.application.saps4hana.FieldDataDomain',
	FieldDataElement = 'com.infa.odin.models.application.saps4hana.FieldDataElement',
	FieldOffset = 'com.infa.odin.models.application.saps4hana.FieldOffset',
	FunctionalArea = 'com.infa.odin.models.application.saps4hana.FunctionalArea',
	KeyFlag = 'com.infa.odin.models.application.saps4hana.KeyFlag',
	ProgramName = 'com.infa.odin.models.application.saps4hana.ProgramName',
	RCStore = 'com.infa.odin.models.application.saps4hana.RCStore',
	RefField = 'com.infa.odin.models.application.saps4hana.RefField',
	RefTable = 'com.infa.odin.models.application.saps4hana.RefTable',
	Rfchost = 'com.infa.odin.models.application.saps4hana.Rfchost',
	Scrtext_m = 'com.infa.odin.models.application.saps4hana.Scrtext_m',
	Scrtext_s = 'com.infa.odin.models.application.saps4hana.Scrtext_s',
	TableClass = 'com.infa.odin.models.application.saps4hana.TableClass',
	Type = 'com.infa.odin.models.application.saps4hana.Type',
	ViewType = 'com.infa.odin.models.application.saps4hana.ViewType',
}

export enum SSISAttr {
	CalculationComplexity = 'com.infa.odin.models.SSIS.calculationComplexity',
	ControlConditions = 'com.infa.odin.models.SSIS.controlConditions',
	Expression = 'com.infa.odin.models.SSIS.expression',
	HtmlLink = 'com.infa.odin.models.SSIS.htmlLink',
	SourceStatement = 'com.infa.odin.models.SSIS.sourceStatement',
	TaskType = 'com.infa.odin.models.SSIS.taskType',
}

export enum SSRSAttr {
	CalculationComplexity = 'com.infa.odin.models.SSRS.calculationComplexity',
	ControlConditions = 'com.infa.odin.models.SSRS.controlConditions',
	Expression = 'com.infa.odin.models.SSRS.expression',
}

export enum SalesforceAttr {
	ApiVersion = 'com.infa.odin.models.Salesforce.ApiVersion',
	AscendingLabel = 'com.infa.odin.models.Salesforce.AscendingLabel',
	AssociateEntityType = 'com.infa.odin.models.Salesforce.AssociateEntityType',
	AssociateParentEntity = 'com.infa.odin.models.Salesforce.AssociateParentEntity',
	AutoNumber = 'com.infa.odin.models.Salesforce.AutoNumber',
	Body = 'com.infa.odin.models.Salesforce.Body',
	BodyCrc = 'com.infa.odin.models.Salesforce.BodyCrc',
	ByteLength = 'com.infa.odin.models.Salesforce.ByteLength',
	Calculated = 'com.infa.odin.models.Salesforce.Calculated',
	CalculatedFormula = 'com.infa.odin.models.Salesforce.CalculatedFormula',
	CascadeDelete = 'com.infa.odin.models.Salesforce.CascadeDelete',
	CaseSensitive = 'com.infa.odin.models.Salesforce.CaseSensitive',
	Comment = 'com.infa.odin.models.Salesforce.Comment',
	CompactLayoutable = 'com.infa.odin.models.Salesforce.CompactLayoutable',
	CompoundFieldName = 'com.infa.odin.models.Salesforce.CompoundFieldName',
	ControllerName = 'com.infa.odin.models.Salesforce.ControllerName',
	Createable = 'com.infa.odin.models.Salesforce.Createable',
	CreatedById = 'com.infa.odin.models.Salesforce.CreatedById',
	CreatedDate = 'com.infa.odin.models.Salesforce.CreatedDate',
	Custom = 'com.infa.odin.models.Salesforce.Custom',
	CustomSetting = 'com.infa.odin.models.Salesforce.CustomSetting',
	DataTranslationEnabled = 'com.infa.odin.models.Salesforce.DataTranslationEnabled',
	Datatype = 'com.infa.odin.models.Salesforce.Datatype',
	DatatypeLength = 'com.infa.odin.models.Salesforce.DatatypeLength',
	DatatypeScale = 'com.infa.odin.models.Salesforce.DatatypeScale',
	DefaultValue = 'com.infa.odin.models.Salesforce.DefaultValue',
	DefaultValueFormula = 'com.infa.odin.models.Salesforce.DefaultValueFormula',
	DefaultedOnCreate = 'com.infa.odin.models.Salesforce.DefaultedOnCreate',
	Deletable = 'com.infa.odin.models.Salesforce.Deletable',
	DependentPicklist = 'com.infa.odin.models.Salesforce.DependentPicklist',
	DescendingLabel = 'com.infa.odin.models.Salesforce.DescendingLabel',
	Digits = 'com.infa.odin.models.Salesforce.Digits',
	DisplayLocationInDecimal = 'com.infa.odin.models.Salesforce.DisplayLocationInDecimal',
	Encrypted = 'com.infa.odin.models.Salesforce.Encrypted',
	EntityDefinitionId = 'com.infa.odin.models.Salesforce.EntityDefinitionId',
	ExternalID = 'com.infa.odin.models.Salesforce.ExternalID',
	ExtraTypeInfo = 'com.infa.odin.models.Salesforce.ExtraTypeInfo',
	FeedEnabled = 'com.infa.odin.models.Salesforce.FeedEnabled',
	FieldNameOrPath = 'com.infa.odin.models.Salesforce.FieldNameOrPath',
	Filterable = 'com.infa.odin.models.Salesforce.Filterable',
	FormulaTreatNullNumberAsZero = 'com.infa.odin.models.Salesforce.FormulaTreatNullNumberAsZero',
	Groupable = 'com.infa.odin.models.Salesforce.Groupable',
	Hidden = 'com.infa.odin.models.Salesforce.Hidden',
	HighScaleNumber = 'com.infa.odin.models.Salesforce.HighScaleNumber',
	HtmlFormatted = 'com.infa.odin.models.Salesforce.HtmlFormatted',
	Id = 'com.infa.odin.models.Salesforce.Id',
	IdLookup = 'com.infa.odin.models.Salesforce.IdLookup',
	InlineHelpText = 'com.infa.odin.models.Salesforce.InlineHelpText',
	IsValid = 'com.infa.odin.models.Salesforce.isValid',
	KeyPrefix = 'com.infa.odin.models.Salesforce.KeyPrefix',
	Label = 'com.infa.odin.models.Salesforce.Label',
	LabelPlural = 'com.infa.odin.models.Salesforce.LabelPlural',
	LastModifiedById = 'com.infa.odin.models.Salesforce.LastModifiedById',
	LastModifiedDate = 'com.infa.odin.models.Salesforce.LastModifiedDate',
	Layoutable = 'com.infa.odin.models.Salesforce.Layoutable',
	LengthWithoutComments = 'com.infa.odin.models.Salesforce.LengthWithoutComments',
	MRUEnabled = 'com.infa.odin.models.Salesforce.MRUEnabled',
	ManageableState = 'com.infa.odin.models.Salesforce.ManageableState',
	Mergeable = 'com.infa.odin.models.Salesforce.Mergeable',
	NameField = 'com.infa.odin.models.Salesforce.NameField',
	NamePointing = 'com.infa.odin.models.Salesforce.NamePointing',
	NamedLayoutInfos = 'com.infa.odin.models.Salesforce.NamedLayoutInfos',
	NamespacePrefix = 'com.infa.odin.models.Salesforce.NamespacePrefix',
	NetworkScopeFieldName = 'com.infa.odin.models.Salesforce.NetworkScopeFieldName',
	Nillable = 'com.infa.odin.models.Salesforce.Nillable',
	Permissionable = 'com.infa.odin.models.Salesforce.Permissionable',
	PicklistValues = 'com.infa.odin.models.Salesforce.PicklistValues',
	PolymorphicForeignKey = 'com.infa.odin.models.Salesforce.PolymorphicForeignKey',
	Precision = 'com.infa.odin.models.Salesforce.Precision',
	Query = 'com.infa.odin.models.Salesforce.Query',
	Queryable = 'com.infa.odin.models.Salesforce.Queryable',
	ReferenceTargetField = 'com.infa.odin.models.Salesforce.ReferenceTargetField',
	RelationshipName = 'com.infa.odin.models.Salesforce.RelationshipName',
	RelationshipOrder = 'com.infa.odin.models.Salesforce.RelationshipOrder',
	Replicateable = 'com.infa.odin.models.Salesforce.Replicateable',
	RestrictedDelete = 'com.infa.odin.models.Salesforce.RestrictedDelete',
	RestrictedPicklist = 'com.infa.odin.models.Salesforce.RestrictedPicklist',
	Retrieveable = 'com.infa.odin.models.Salesforce.Retrieveable',
	SObjectType = 'com.infa.odin.models.Salesforce.SObjectType',
	Scope = 'com.infa.odin.models.Salesforce.Scope',
	SearchLayoutable = 'com.infa.odin.models.Salesforce.SearchLayoutable',
	SearchPrefilterable = 'com.infa.odin.models.Salesforce.SearchPrefilterable',
	Searchable = 'com.infa.odin.models.Salesforce.Searchable',
	SoapType = 'com.infa.odin.models.Salesforce.SoapType',
	SortDirection = 'com.infa.odin.models.Salesforce.SortDirection',
	SortIndex = 'com.infa.odin.models.Salesforce.SortIndex',
	Sortable = 'com.infa.odin.models.Salesforce.Sortable',
	Status = 'com.infa.odin.models.Salesforce.Status',
	SupportedScopes = 'com.infa.odin.models.Salesforce.SupportedScopes',
	SystemModstamp = 'com.infa.odin.models.Salesforce.SystemModstamp',
	TableEnumOrId = 'com.infa.odin.models.Salesforce.TableEnumOrId',
	Triggerable = 'com.infa.odin.models.Salesforce.Triggerable',
	Type = 'com.infa.odin.models.Salesforce.Type',
	Undeletable = 'com.infa.odin.models.Salesforce.Undeletable',
	Unique = 'com.infa.odin.models.Salesforce.Unique',
	Updateable = 'com.infa.odin.models.Salesforce.Updateable',
	UsageAfterDelete = 'com.infa.odin.models.Salesforce.UsageAfterDelete',
	UsageAfterInsert = 'com.infa.odin.models.Salesforce.UsageAfterInsert',
	UsageAfterUndelete = 'com.infa.odin.models.Salesforce.UsageAfterUndelete',
	UsageAfterUpdate = 'com.infa.odin.models.Salesforce.UsageAfterUpdate',
	UsageBeforeDelete = 'com.infa.odin.models.Salesforce.UsageBeforeDelete',
	UsageBeforeInsert = 'com.infa.odin.models.Salesforce.UsageBeforeInsert',
	UsageBeforeUpdate = 'com.infa.odin.models.Salesforce.UsageBeforeUpdate',
	UsageIsBulk = 'com.infa.odin.models.Salesforce.UsageIsBulk',
	ViewName = 'com.infa.odin.models.Salesforce.ViewName',
	WriteRequiresMasterRead = 'com.infa.odin.models.Salesforce.WriteRequiresMasterRead',
}

export enum SappdAttr {
	AliasName = 'com.infa.odin.models.sappd.AliasName',
	Author = 'com.infa.odin.models.sappd.Author',
	Cardinality = 'com.infa.odin.models.sappd.Cardinality',
	Clustered = 'com.infa.odin.models.sappd.Clustered',
	Code = 'com.infa.odin.models.sappd.Code',
	Constraint = 'com.infa.odin.models.sappd.Constraint',
	CreationTime = 'com.infa.odin.models.sappd.CreationTime',
	Cycle = 'com.infa.odin.models.sappd.Cycle',
	DefaultAggregation = 'com.infa.odin.models.sappd.DefaultAggregation',
	DefaultValue = 'com.infa.odin.models.sappd.DefaultValue',
	Definition = 'com.infa.odin.models.sappd.Definition',
	DesignLevel = 'com.infa.odin.models.sappd.DesignLevel',
	DimensionType = 'com.infa.odin.models.sappd.DimensionType',
	DimensionalRole = 'com.infa.odin.models.sappd.DimensionalRole',
	DimensionalType = 'com.infa.odin.models.sappd.DimensionalType',
	Expression = 'com.infa.odin.models.sappd.Expression',
	FireOnDelete = 'com.infa.odin.models.sappd.FireOnDelete',
	FireOnInsert = 'com.infa.odin.models.sappd.FireOnInsert',
	FireOnUpdate = 'com.infa.odin.models.sappd.FireOnUpdate',
	Generate = 'com.infa.odin.models.sappd.Generate',
	Group = 'com.infa.odin.models.sappd.Group',
	GroupByClause = 'com.infa.odin.models.sappd.GroupByClause',
	HavingClause = 'com.infa.odin.models.sappd.HavingClause',
	Hide = 'com.infa.odin.models.sappd.Hide',
	Identifying = 'com.infa.odin.models.sappd.Identifying',
	IncrementValue = 'com.infa.odin.models.sappd.IncrementValue',
	InitialValue = 'com.infa.odin.models.sappd.InitialValue',
	Length = 'com.infa.odin.models.sappd.Length',
	LowerBound = 'com.infa.odin.models.sappd.LowerBound',
	MaximumValue = 'com.infa.odin.models.sappd.MaximumValue',
	MinimumValue = 'com.infa.odin.models.sappd.MinimumValue',
	ModificationTime = 'com.infa.odin.models.sappd.ModificationTime',
	Modifier = 'com.infa.odin.models.sappd.Modifier',
	NativeDataType = 'com.infa.odin.models.sappd.NativeDataType',
	NativeId = 'com.infa.odin.models.sappd.NativeId',
	NativeLogicalDataType = 'com.infa.odin.models.sappd.NativeLogicalDataType',
	NativeType = 'com.infa.odin.models.sappd.NativeType',
	Notation = 'com.infa.odin.models.sappd.Notation',
	Nullable = 'com.infa.odin.models.sappd.Nullable',
	OnDelete = 'com.infa.odin.models.sappd.OnDelete',
	OnInsert = 'com.infa.odin.models.sappd.OnInsert',
	OnUpdate = 'com.infa.odin.models.sappd.OnUpdate',
	Operation = 'com.infa.odin.models.sappd.Operation',
	OperationDescription = 'com.infa.odin.models.sappd.OperationDescription',
	Optional = 'com.infa.odin.models.sappd.Optional',
	OrderByClause = 'com.infa.odin.models.sappd.OrderByClause',
	OriginalName = 'com.infa.odin.models.sappd.OriginalName',
	PhysicalName = 'com.infa.odin.models.sappd.PhysicalName',
	Postcondition = 'com.infa.odin.models.sappd.Postcondition',
	Precondition = 'com.infa.odin.models.sappd.Precondition',
	Scale = 'com.infa.odin.models.sappd.Scale',
	Scope = 'com.infa.odin.models.sappd.Scope',
	SelectType = 'com.infa.odin.models.sappd.SelectType',
	Sequence = 'com.infa.odin.models.sappd.Sequence',
	Sort = 'com.infa.odin.models.sappd.Sort',
	Source = 'com.infa.odin.models.sappd.Source',
	StartValue = 'com.infa.odin.models.sappd.StartValue',
	StoreType = 'com.infa.odin.models.sappd.StoreType',
	SystemMajorVersion = 'com.infa.odin.models.sappd.SystemMajorVersion',
	SystemMinorVersion = 'com.infa.odin.models.sappd.SystemMinorVersion',
	SystemReleaseVersion = 'com.infa.odin.models.sappd.SystemReleaseVersion',
	SystemType = 'com.infa.odin.models.sappd.SystemType',
	SystemTypeOld = 'com.infa.odin.models.sappd.SystemTypeOld',
	Text = 'com.infa.odin.models.sappd.Text',
	TriggerType = 'com.infa.odin.models.sappd.TriggerType',
	Type = 'com.infa.odin.models.sappd.Type',
	TypeName = 'com.infa.odin.models.sappd.TypeName',
	Unique = 'com.infa.odin.models.sappd.Unique',
	UniqueKey = 'com.infa.odin.models.sappd.UniqueKey',
	UpperBound = 'com.infa.odin.models.sappd.UpperBound',
	Usage = 'com.infa.odin.models.sappd.Usage',
	UserDataType = 'com.infa.odin.models.sappd.UserDataType',
	Value = 'com.infa.odin.models.sappd.Value',
	ViewStatement = 'com.infa.odin.models.sappd.ViewStatement',
	ViewStatementType = 'com.infa.odin.models.sappd.ViewStatementType',
	ViewType = 'com.infa.odin.models.sappd.ViewType',
	WhereClause = 'com.infa.odin.models.sappd.WhereClause',
}

export enum ScriptAttr {
	CallStackTrace = 'com.infa.odin.models.Script.callStackTrace',
	SourceCode = 'com.infa.odin.models.Script.sourceCode',
	SourceStatementText = 'com.infa.odin.models.Script.sourceStatementText',
	StatementCommentText = 'com.infa.odin.models.Script.statementCommentText',
}

export enum SupplementAttr {
	AverageRating = 'core.supplement.averageRating',
	BaseCommentId = 'core.supplement.baseCommentId',
	CertificationAssetId = 'core.supplement.certificationAssetId',
	CertificationModificationTime = 'core.supplement.certificationModificationTime',
	CertificationValue = 'core.supplement.certificationValue',
	Certified = 'core.supplement.certified',
	CertifiedBy = 'core.supplement.certifiedBy',
	CommentText = 'core.supplement.commentText',
	CommentedBy = 'core.supplement.commentedBy',
	RatedBy = 'core.supplement.ratedBy',
	RatingAssetId = 'core.supplement.ratingAssetId',
	RatingModificationTime = 'core.supplement.ratingModificationTime',
	RatingValue = 'core.supplement.ratingValue',
	Reaction = 'core.supplement.reaction',
	UserInteraction = 'core.supplement.userInteraction',
	UserInteractionAssetId = 'core.supplement.userInteractionAssetId',
	UserInteractionModificationTime = 'core.supplement.userInteractionModificationTime',
}

export enum TableauAttr {
	CalculationComplexity = 'com.infa.odin.models.Tableau.calculationComplexity',
	ControlConditions = 'com.infa.odin.models.Tableau.controlConditions',
	Expression = 'com.infa.odin.models.Tableau.expression',
	HtmlLink = 'com.infa.odin.models.Tableau.htmlLink',
}

export enum TicketAttr {
	AssetId = 'com.infa.ccgf.models.issueManagement.assetId',
	AssetName = 'com.infa.ccgf.models.issueManagement.assetName',
	AssetType = 'com.infa.ccgf.models.issueManagement.assetType',
	CurrentStepId = 'com.infa.ccgf.models.issueManagement.currentStepId',
	CurrentTaskAssigneeGroups = 'com.infa.ccgf.models.issueManagement.currentTaskAssigneeGroups',
	CurrentTaskAssigneeRoles = 'com.infa.ccgf.models.issueManagement.currentTaskAssigneeRoles',
	CurrentTaskAssigneeUsers = 'com.infa.ccgf.models.issueManagement.currentTaskAssigneeUsers',
	CurrentTaskDueDate = 'com.infa.ccgf.models.issueManagement.currentTaskDueDate',
	CurrentTaskName = 'com.infa.ccgf.models.issueManagement.currentTaskName',
	IssueId = 'com.infa.ccgf.models.issueManagement.issueId',
	IssueResolvedBy = 'com.infa.ccgf.models.issueManagement.issueResolvedBy',
	IssueResolvedOn = 'com.infa.ccgf.models.issueManagement.issueResolvedOn',
	IssueSeverity = 'com.infa.ccgf.models.issueManagement.issueSeverity',
	IssueStatus = 'com.infa.ccgf.models.issueManagement.issueStatus',
	IssueTitle = 'com.infa.ccgf.models.issueManagement.issueTitle',
	IssueType = 'com.infa.ccgf.models.issueManagement.issueType',
	IssueUrgency = 'com.infa.ccgf.models.issueManagement.issueUrgency',
	ProcessId = 'com.infa.ccgf.models.issueManagement.processId',
	Resolution = 'com.infa.ccgf.models.issueManagement.resolution',
	ResolutionType = 'com.infa.ccgf.models.issueManagement.resolutionType',
	RuleOccurrenceIds = 'com.infa.ccgf.models.issueManagement.ruleOccurrenceIds',
	WorkflowId = 'com.infa.ccgf.models.issueManagement.workflowId',
	WorkflowName = 'com.infa.ccgf.models.issueManagement.workflowName',
}
